import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import { Edit, ViewIcon } from "../../../icons";
import formatDateTime from "../../Common/formatDateTime";
import SEO from "../../Common/SEO";
import { ToastManager } from "../../Toast/ToastManager";
import CompanyNewsView from "./CompanyNewsView";
import { SESSION_AUTH } from "../../../common/auth";
import { EXCHANGE_SERVICES } from "../../../services";
import "./style.scss";

const CompanyNews = props => {
  const { orgStocks, orgName } = props;
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [listData, setListData] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newsView, setNewsView] = useState("");

  const [selectedStock, setSelectedStock] = useState("");

  useEffect(() => {
    if (!orgStocks) return;
    let stock = orgStocks?.find(stock => stock.primary === true);
    setSelectedStock(stock);
  }, [orgStocks]);

  useEffect(() => {
    if (dataFetched || !selectedStock) return;
    setDataFetched(true);
    setLoading(true);
    let parma = {
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
      symbol: selectedStock?.symbol,
      exSystem: selectedStock?.exSystem,
    };

    EXCHANGE_SERVICES.stockNews(parma)
      .then(data => {
        if (data.code === 200) {
          setListData(data.data);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dataFetched, selectedStock, isUserSession, LOGOUT_USER_SESSION]);

  return (
    <React.Fragment>
      <SEO title={`${orgName || "Profile"} | News | 6ix`} />
      <div className="event-page-company-posts-content">
        <TableContainer className="event-page-company-posts-content-table">
          <Table sx={{ minWidth: 550 }} aria-label="post table">
            <TableHead>
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>Headline</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                Array.from({ length: listData?.length || 10 }).map(
                  (_, index) => (
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                      key={index}
                    >
                      <TableCell>
                        <div className="event-page-company-posts-content-table-loading" />
                      </TableCell>
                      <TableCell>
                        <div className="event-page-company-posts-content-table-loading" />
                      </TableCell>
                    </TableRow>
                  )
                )
              ) : listData?.length > 0 ? (
                listData.map((list, index) => (
                  <TableRow
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                    key={index}
                  >
                    <TableCell>
                      {list?.date ? formatDateTime(list?.date) : "-"}
                    </TableCell>
                    <TableCell>
                      <Link
                        className="event-page-company-posts-content-table-title"
                        onClick={() => {
                          setNewsView(list);
                        }}
                      >
                        {list?.title}
                      </Link>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell colSpan="3">
                    <div className="event-page-company-posts-content-empty">
                      Looks like there's nothing to report right now.
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {newsView ? (
        <CompanyNewsView
          news={newsView}
          onClose={() => {
            setNewsView("");
          }}
        />
      ) : null}
    </React.Fragment>
  );
};

export default CompanyNews;
